import { render, staticRenderFns } from "./YogaMap.vue?vue&type=template&id=1b4b2b8c&"
import script from "./YogaMap.vue?vue&type=script&lang=js&"
export * from "./YogaMap.vue?vue&type=script&lang=js&"
import style0 from "./YogaMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports